<!-- @format -->

<sis-expandable [title]="'SUBSTITUTIONS.SELECTOR.TITLE' | transloco" [level]="4" [closed]="false">
  <ng-template sisExpandableContent>
    @if (hasSubstitutes) {
      <div>
        @if (isSubstitute) {
          <sis-contextual-notification variant="warning">{{
            "SUBSTITUTIONS.UNABLE_TO_SUBSTITUTE" | transloco
          }}</sis-contextual-notification>
        }
        <p><transloco key="{{ 'SUBSTITUTIONS.SELECTOR.SUBSTITUTE_INFORMATION' }}"></transloco></p>
        @if (hasSomeSubstitutesToSelect) {
          <p><transloco key="{{ 'SUBSTITUTIONS.SELECTOR.SUBSTITUTE_SELECT_INFORMATION' }}"></transloco></p>
        }
        <form novalidate>
          <fieldset>
            <legend class="sis-label">{{ "SUBSTITUTIONS.SELECTOR.SUBTITLE" | transloco }}</legend>
            <div [attr.disabled]="isSubstitute" id="substitutions-form-group">
              @if (hasSomeSubstitutesToSelect) {
                <sis-radio-button
                  [control]="selectedSubstitutionsLocalId"
                  [value]="null"
                  [inline]="true"
                  [label]="'SUBSTITUTIONS.SELECTOR.NO'">
                </sis-radio-button>
              }
              @for (
                substitutionOption of mySubstitutionOptions;
                track substitutionOptionByLocalId(substitutionOptionIndex, substitutionOption);
                let substitutionOptionIndex = $index
              ) {
                <div>
                  @if (showAsGrouped) {
                    <h5 class="sis-label">
                      {{ ("STUDIES.COURSE_UNIT_INFO_MODAL.SUBSTITUTIONS_OPTION" | translate) + " " + (substitutionOptionIndex + 1) }}
                    </h5>
                  }
                  <div [ngClass]="showAsGrouped ? 'substitution-container-no-radio' : 'substitution-container'">
                    <div class="radio-button-substitution-option">
                      @if (substitutionOption.isSelectable) {
                        <sis-radio-button [control]="selectedSubstitutionsLocalId" [value]="substitutionOption.localId"> </sis-radio-button>
                      }
                    </div>
                    <div class="substitution-course-units">
                      @for (courseUnitSubstitution of substitutionOption.substitution; track courseUnitSubstitution) {
                        <div
                          [class.course-unit-substitution-group]="
                            substitutionOption.isGroup || substitutionOption.isAttainmentAlreadyAttached
                          ">
                          @if (substituteCourseUnitsByGroupId && substituteCourseUnitsByGroupId[courseUnitSubstitution.courseUnitGroupId]) {
                            <sis-course-unit-box
                              [courseUnit]="substituteCourseUnitsByGroupId[courseUnitSubstitution.courseUnitGroupId]"
                              [attainment]="getAttainmentByCourseUnitGroupId(courseUnitSubstitution.courseUnitGroupId)"
                              [categoryCssClass]="'cu-color-' + (substitutionOptionIndex + 1)"
                              (codeClickAction)="handleOpenCourseUnitInfoModal($event)">
                              @if (courseUnitSubstitution.credits) {
                                <div course-unit-box="notifications" class="cu-notification-bar">
                                  <sis-tooltip
                                    [tooltipText]="'SUBSTITUTIONS.CREDITS' | transloco: { credits: courseUnitSubstitution.credits }">
                                    <span class="cu-notification sis-tooltip-trigger-content">
                                      <span class="cu-notification-header"><sis-icon icon="info"></sis-icon></span>
                                      <span class="cu-notification-content">{{
                                        "SUBSTITUTIONS.CREDITS" | transloco: { credits: courseUnitSubstitution.credits }
                                      }}</span>
                                    </span>
                                  </sis-tooltip>
                                </div>
                              }
                            </sis-course-unit-box>
                          }
                        </div>
                      }
                      @if (substitutionOption.isAttainmentAlreadyAttached) {
                        <sis-contextual-notification variant="warning">{{
                          "SUBSTITUTIONS.ATTAINMENT_ALREADY_ATTACHED" | transloco
                        }}</sis-contextual-notification>
                      }
                      @if (isEditable && substitutionOption.isSubstituteCourseUnitAlreadyInPlan) {
                        <sis-contextual-notification variant="warning">{{
                          "SUBSTITUTIONS.COURSE_UNIT_ALREADY_IN_PLAN" | transloco
                        }}</sis-contextual-notification>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </fieldset>
        </form>
        @if (courseUnit.equivalentCoursesInfo) {
          <sis-localized-markup-string-view class="equivalent-courses-info" [content]="courseUnit.equivalentCoursesInfo">
          </sis-localized-markup-string-view>
        }
      </div>
    }

    @if (!hasSubstitutes) {
      <div>
        <p class="sis-placeholder">{{ "SUBSTITUTIONS.SELECTOR.TITLE_NONE" | transloco }}</p>
      </div>
    }
  </ng-template>
</sis-expandable>
